export default __webpack_public_path__ + "static/media/004-pub.8c93baa4.svg";